import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3efbdbb5"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3efbdbb5')) {
      api.createRecord('3efbdbb5', component.options)
    } else {
      api.reload('3efbdbb5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3efbdbb5", function () {
      api.rerender('3efbdbb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/index.vue"
export default component.exports